import React from 'react';
import './Pagination.css';

function Pagination({ current, totalPages, onPageChange }) {
  const pages = [];
  const maxVisible = 10; // 최대 표시 페이지 번호 개수

  // 시작/끝 페이지 계산
  let startPage = Math.max(1, current - Math.floor(maxVisible / 2));
  let endPage = Math.min(totalPages, startPage + maxVisible - 1);

  // 끝에서 시작 위치 조정
  if (endPage - startPage + 1 < maxVisible) {
    startPage = Math.max(1, endPage - maxVisible + 1);
  }

  // 이전 버튼
  if (current > 1) {
    pages.push(
      <button
        key="prev"
        className="page-btn"
        onClick={() => onPageChange(current - 1)}
      >
        ◀
      </button>
    );
  }

  // 첫 페이지
  if (startPage > 1) {
    pages.push(
      <button
        key={1}
        className="page-btn"
        onClick={() => onPageChange(1)}
      >
        1
      </button>
    );
    if (startPage > 2) {
      pages.push(<span key="ellipsis1" className="ellipsis">...</span>);
    }
  }

  // 페이지 번호들
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <button
        key={i}
        className={`page-btn ${current === i ? 'active' : ''}`}
        onClick={() => onPageChange(i)}
      >
        {i}
      </button>
    );
  }

  // 마지막 페이지
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<span key="ellipsis2" className="ellipsis">...</span>);
    }
    pages.push(
      <button
        key={totalPages}
        className="page-btn"
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </button>
    );
  }

  // 다음 버튼
  if (current < totalPages) {
    pages.push(
      <button
        key="next"
        className="page-btn"
        onClick={() => onPageChange(current + 1)}
      >
        ▶
      </button>
    );
  }

  return (
    <div className="pagination">
      {pages}
    </div>
  );
}

export default Pagination;
